import QRCode from "qrcode";
import { useEffect, useState, type FormEvent } from "react";
import { auth, ErroApi, type EtapaLogin } from "../api";

/** Login com e-mail, senha e aplicativo autenticador (TOTP). Primeiro acesso: senha nova e cadastro do autenticador. */
export function Login({ aoEntrar }: { aoEntrar: () => void }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [codigo, setCodigo] = useState("");
  const [etapa, setEtapa] = useState<EtapaLogin | { etapa: "inicio" }>({ etapa: "inicio" });
  const [qr, setQr] = useState<string>();
  const [erro, setErro] = useState<string>();
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    if (etapa.etapa === "confirmar_mfa") void QRCode.toDataURL(etapa.otpauth, { margin: 1, width: 220 }).then(setQr);
  }, [etapa]);

  const seguir = async (f: () => Promise<EtapaLogin>) => {
    setErro(undefined);
    setOcupado(true);
    try {
      let e = await f();
      if (e.etapa === "configurar_mfa") e = await auth.configurarMfa(email, e.sessao);
      setCodigo("");
      if (e.etapa === "ok") aoEntrar();
      else setEtapa(e);
    } catch (x) {
      setErro(x instanceof ErroApi ? x.message : "não foi possível falar com o Hub");
    } finally {
      setOcupado(false);
    }
  };

  const enviar = (ev: FormEvent) => {
    ev.preventDefault();
    switch (etapa.etapa) {
      case "inicio": return void seguir(() => auth.entrar(email, senha));
      case "nova_senha": return void seguir(() => auth.novaSenha(email, etapa.sessao, senha));
      case "confirmar_mfa": return void seguir(() => auth.confirmarMfa(email, etapa.sessao, codigo));
      case "mfa": return void seguir(() => auth.mfa(email, etapa.sessao, codigo));
    }
  };

  return (
    <form className="login cartao" onSubmit={enviar}>
      <h1>Escalando IA</h1>
      {etapa.etapa === "inicio" && (
        <>
          <label htmlFor="email">E-mail</label>
          <input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <label htmlFor="senha">Senha</label>
          <input id="senha" type="password" autoComplete="current-password" required value={senha} onChange={(e) => setSenha(e.target.value)} />
        </>
      )}
      {etapa.etapa === "nova_senha" && (
        <>
          <p>Primeiro acesso: escolha uma senha nova (mínimo de 12 caracteres, com maiúsculas, minúsculas e números).</p>
          <label htmlFor="nova">Senha nova</label>
          <input id="nova" type="password" autoComplete="new-password" required minLength={12} value={senha} onChange={(e) => setSenha(e.target.value)} />
        </>
      )}
      {etapa.etapa === "confirmar_mfa" && (
        <>
          <p>Abra o aplicativo autenticador (Google ou Microsoft Authenticator), leia o código QR e digite os 6 números.</p>
          {qr && <img className="qr" src={qr} alt="Código QR do autenticador" width={220} height={220} />}
          <p className="suave">Sem câmera? Digite esta chave no aplicativo: <span className="segredo">{etapa.segredo}</span></p>
        </>
      )}
      {(etapa.etapa === "confirmar_mfa" || etapa.etapa === "mfa") && (
        <>
          <label htmlFor="codigo">Código do autenticador</label>
          <input id="codigo" inputMode="numeric" autoComplete="one-time-code" pattern="\d{6}" maxLength={6} required autoFocus value={codigo} onChange={(e) => setCodigo(e.target.value.replace(/\D/g, ""))} />
        </>
      )}
      {erro && <p className="erro" role="alert">{erro}</p>}
      <p><button className="primario" type="submit" disabled={ocupado} style={{ width: "100%" }}>{ocupado ? "Aguarde…" : "Continuar"}</button></p>
      {etapa.etapa !== "inicio" && <button type="button" onClick={() => { setEtapa({ etapa: "inicio" }); setSenha(""); }}>Voltar</button>}
    </form>
  );
}
